import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
import { PermitModelFieldsFragmentDoc } from './SitePermits.generated'
const defaultOptions = {}
export type IUploadLogFieldsFragment = {
  fileType?: string | null
  fileCategory?: Types.FileCategory | null
  fileUrl?: string | null
  id?: any | null
  locationIds?: Array<any | null> | null
  locationName?: string | null
  projectId?: any | null
  projectName?: string | null
  sourceEntityCode?: string | null
  sourceEntityId?: any | null
  sourceEntityType?: Types.SourceEntityType | null
  sourceEntityTypeName?: string | null
  updatedAt?: any | null
  userCompanyId?: any | null
  userCompanyName?: string | null
  userId?: any | null
  userName?: string | null
  version?: number | null
  createdAt?: any | null
  workflowType?: any | null
  workflowCategory?: any | null
  isHidden?: boolean | null
  metadata?: Array<{ key?: string | null; value?: string | null } | null> | null
}

export type IGetSignedUnverifiedUploadUrlQueryVariables = Types.Exact<{
  fileName: Types.Scalars['String']['input']
  uploadingType: Types.Scalars['String']['input']
}>

export type IGetSignedUnverifiedUploadUrlQuery = {
  getSignedUnverifiedUploadUrl?: Array<{
    filePath?: string | null
    signedUrl?: string | null
    contentType?: string | null
  } | null> | null
}

export type IVerifyUploadedFileQueryVariables = Types.Exact<{
  input: Types.IGenerateSignedUploadUrlInput
}>

export type IVerifyUploadedFileQuery = {
  verifyUploadedFile?: {
    filePath?: string | null
    signedUrl?: string | null
    fileURL?: string | null
    contentType?: string | null
    uploadLog?: {
      fileType?: string | null
      fileCategory?: Types.FileCategory | null
      fileUrl?: string | null
      id?: any | null
      locationIds?: Array<any | null> | null
      locationName?: string | null
      projectId?: any | null
      projectName?: string | null
      sourceEntityCode?: string | null
      sourceEntityId?: any | null
      sourceEntityType?: Types.SourceEntityType | null
      sourceEntityTypeName?: string | null
      updatedAt?: any | null
      userCompanyId?: any | null
      userCompanyName?: string | null
      userId?: any | null
      userName?: string | null
      version?: number | null
      createdAt?: any | null
      workflowType?: any | null
      workflowCategory?: any | null
      isHidden?: boolean | null
      metadata?: Array<{
        key?: string | null
        value?: string | null
      } | null> | null
    } | null
  } | null
}

export type IGetUploadLogsQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
}>

export type IGetUploadLogsQuery = {
  getUploadLogs?: Array<{
    fileType?: string | null
    fileCategory?: Types.FileCategory | null
    fileUrl?: string | null
    id?: any | null
    locationIds?: Array<any | null> | null
    locationName?: string | null
    projectId?: any | null
    projectName?: string | null
    sourceEntityCode?: string | null
    sourceEntityId?: any | null
    sourceEntityType?: Types.SourceEntityType | null
    sourceEntityTypeName?: string | null
    updatedAt?: any | null
    userCompanyId?: any | null
    userCompanyName?: string | null
    userId?: any | null
    userName?: string | null
    version?: number | null
    createdAt?: any | null
    workflowType?: any | null
    workflowCategory?: any | null
    isHidden?: boolean | null
    metadata?: Array<{
      key?: string | null
      value?: string | null
    } | null> | null
  } | null> | null
}

export type IDeleteUploadLogMutationVariables = Types.Exact<{
  uploadLogId: Types.Scalars['ObjectId']['input']
}>

export type IDeleteUploadLogMutation = { deleteUploadLog?: boolean | null }

export type ISaveUploadLogMutationVariables = Types.Exact<{
  uploadLog: Types.IUploadLogInput
}>

export type ISaveUploadLogMutation = {
  saveUploadLog?: {
    fileType?: string | null
    fileCategory?: Types.FileCategory | null
    fileUrl?: string | null
    id?: any | null
    locationIds?: Array<any | null> | null
    locationName?: string | null
    projectId?: any | null
    projectName?: string | null
    sourceEntityCode?: string | null
    sourceEntityId?: any | null
    sourceEntityType?: Types.SourceEntityType | null
    sourceEntityTypeName?: string | null
    updatedAt?: any | null
    userCompanyId?: any | null
    userCompanyName?: string | null
    userId?: any | null
    userName?: string | null
    version?: number | null
    createdAt?: any | null
    workflowType?: any | null
    workflowCategory?: any | null
    isHidden?: boolean | null
    metadata?: Array<{
      key?: string | null
      value?: string | null
    } | null> | null
  } | null
}

export type IUploadLogAggregatedFieldsFragment = {
  uploadLog: {
    fileType?: string | null
    fileCategory?: Types.FileCategory | null
    fileUrl?: string | null
    id?: any | null
    locationIds?: Array<any | null> | null
    locationName?: string | null
    projectId?: any | null
    projectName?: string | null
    sourceEntityCode?: string | null
    sourceEntityId?: any | null
    sourceEntityType?: Types.SourceEntityType | null
    sourceEntityTypeName?: string | null
    updatedAt?: any | null
    userCompanyId?: any | null
    userCompanyName?: string | null
    userId?: any | null
    userName?: string | null
    version?: number | null
    createdAt?: any | null
    workflowType?: any | null
    workflowCategory?: any | null
    isHidden?: boolean | null
    metadata?: Array<{
      key?: string | null
      value?: string | null
    } | null> | null
  }
  delivery?: {
    id?: any | null
    bookingId?: string | null
    note?: string | null
  } | null
  sitePermit?: {
    createdAt?: any | null
    createdBy: any
    endDate: any
    id?: any | null
    projectId: any
    startDate: any
    status: Types.SitePermitStatus
    threadId?: any | null
    title?: string | null
    typeId: any
    initialType?: string | null
    categoryId?: any | null
    linkedIn?: Array<any | null> | null
    linkedWorkflows?: Array<any | null> | null
    updatedAt?: any | null
    code?: string | null
    currentWorkflowStepId: any
    workflowStepLevel?: number | null
    isAutoActivationEnabled?: boolean | null
    recurringSettingsId?: any | null
    isDeleted?: boolean | null
    isAllDay?: boolean | null
    isLateRequest?: boolean | null
    specificInspectionOptions?: {
      deadlineTime?: any | null
      inspectionFrequency?: number | null
      inspectionFrequencyType?: Types.CalendricalType | null
      selectedDaysToRepeat?: Array<number | null> | null
    } | null
    stepSubmissions?: Array<{
      stepId: any
      userId: any
      submittedAt: any
      fields?: Array<
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            attachmentValues?: Array<{
              fileName: string
              size: string
              url: string
            } | null> | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            checklistValues?: Array<{
              checklistItemId?: any | null
              answer?: boolean | null
            } | null> | null
          }
        | {
            dateTimeValues?: Array<any | null> | null
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            locationValues?: Array<{
              id: any
              type?: Types.LocationType | null
              levels?: Array<string | null> | null
              preciseLocation?: {
                bearing?: number | null
                pitch?: number | null
                latitude?: number | null
                longitude?: number | null
                zoom?: number | null
                globeViewId?: any | null
                imageUrl?: string | null
                overviewImageUrl?: string | null
              } | null
            } | null> | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            materialValues?: Array<{
              materialId: any
              procurementId?: string | null
            } | null> | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            materialResourceValues?: Array<{ locationId: any } | null> | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            measureValues?: Array<{
              units?: string | null
              value?: string | null
            } | null> | null
          }
        | {
            objectIdValues?: Array<any | null> | null
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            richTextValues?: Array<{
              content?: string | null
              attachments?: Array<{
                fileName: string
                size: string
                url: string
              } | null> | null
            } | null> | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            signatureValues?: Array<{
              dataUrl?: string | null
              fontFamily?: string | null
              signatureType: Types.SignatureType
              typedValue?: string | null
              timestamp?: any | null
              userId?: any | null
            } | null> | null
          }
        | {
            stringValues?: Array<string | null> | null
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            tableValues?: Array<{
              cells?: Array<
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    attachmentValues?: Array<{
                      fileName: string
                      size: string
                      url: string
                    } | null> | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    checklistValues?: Array<{
                      checklistItemId?: any | null
                      answer?: boolean | null
                    } | null> | null
                  }
                | {
                    dateTimeValues?: Array<any | null> | null
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    locationValues?: Array<{
                      id: any
                      type?: Types.LocationType | null
                      levels?: Array<string | null> | null
                      preciseLocation?: {
                        bearing?: number | null
                        pitch?: number | null
                        latitude?: number | null
                        longitude?: number | null
                        zoom?: number | null
                        globeViewId?: any | null
                        imageUrl?: string | null
                        overviewImageUrl?: string | null
                      } | null
                    } | null> | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    materialValues?: Array<{
                      materialId: any
                      procurementId?: string | null
                    } | null> | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    materialResourceValues?: Array<{
                      locationId: any
                    } | null> | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    measureValues?: Array<{
                      units?: string | null
                      value?: string | null
                    } | null> | null
                  }
                | {
                    objectIdValues?: Array<any | null> | null
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    richTextValues?: Array<{
                      content?: string | null
                      attachments?: Array<{
                        fileName: string
                        size: string
                        url: string
                      } | null> | null
                    } | null> | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    signatureValues?: Array<{
                      dataUrl?: string | null
                      fontFamily?: string | null
                      signatureType: Types.SignatureType
                      typedValue?: string | null
                      timestamp?: any | null
                      userId?: any | null
                    } | null> | null
                  }
                | {
                    stringValues?: Array<string | null> | null
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                  }
                | null
              > | null
            } | null> | null
          }
        | null
      > | null
    } | null> | null
    fields?: Array<
      | {
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
          attachmentValues?: Array<{
            fileName: string
            size: string
            url: string
          } | null> | null
        }
      | {
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
          checklistValues?: Array<{
            checklistItemId?: any | null
            answer?: boolean | null
          } | null> | null
        }
      | {
          dateTimeValues?: Array<any | null> | null
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
        }
      | {
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
          locationValues?: Array<{
            id: any
            type?: Types.LocationType | null
            levels?: Array<string | null> | null
            preciseLocation?: {
              bearing?: number | null
              pitch?: number | null
              latitude?: number | null
              longitude?: number | null
              zoom?: number | null
              globeViewId?: any | null
              imageUrl?: string | null
              overviewImageUrl?: string | null
            } | null
          } | null> | null
        }
      | {
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
          materialValues?: Array<{
            materialId: any
            procurementId?: string | null
          } | null> | null
        }
      | {
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
          materialResourceValues?: Array<{ locationId: any } | null> | null
        }
      | {
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
          measureValues?: Array<{
            units?: string | null
            value?: string | null
          } | null> | null
        }
      | {
          objectIdValues?: Array<any | null> | null
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
        }
      | {
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
          richTextValues?: Array<{
            content?: string | null
            attachments?: Array<{
              fileName: string
              size: string
              url: string
            } | null> | null
          } | null> | null
        }
      | {
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
          signatureValues?: Array<{
            dataUrl?: string | null
            fontFamily?: string | null
            signatureType: Types.SignatureType
            typedValue?: string | null
            timestamp?: any | null
            userId?: any | null
          } | null> | null
        }
      | {
          stringValues?: Array<string | null> | null
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
        }
      | {
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
          tableValues?: Array<{
            cells?: Array<
              | {
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                  attachmentValues?: Array<{
                    fileName: string
                    size: string
                    url: string
                  } | null> | null
                }
              | {
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                  checklistValues?: Array<{
                    checklistItemId?: any | null
                    answer?: boolean | null
                  } | null> | null
                }
              | {
                  dateTimeValues?: Array<any | null> | null
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                }
              | {
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                  locationValues?: Array<{
                    id: any
                    type?: Types.LocationType | null
                    levels?: Array<string | null> | null
                    preciseLocation?: {
                      bearing?: number | null
                      pitch?: number | null
                      latitude?: number | null
                      longitude?: number | null
                      zoom?: number | null
                      globeViewId?: any | null
                      imageUrl?: string | null
                      overviewImageUrl?: string | null
                    } | null
                  } | null> | null
                }
              | {
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                  materialValues?: Array<{
                    materialId: any
                    procurementId?: string | null
                  } | null> | null
                }
              | {
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                  materialResourceValues?: Array<{
                    locationId: any
                  } | null> | null
                }
              | {
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                  measureValues?: Array<{
                    units?: string | null
                    value?: string | null
                  } | null> | null
                }
              | {
                  objectIdValues?: Array<any | null> | null
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                }
              | {
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                  richTextValues?: Array<{
                    content?: string | null
                    attachments?: Array<{
                      fileName: string
                      size: string
                      url: string
                    } | null> | null
                  } | null> | null
                }
              | {
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                  signatureValues?: Array<{
                    dataUrl?: string | null
                    fontFamily?: string | null
                    signatureType: Types.SignatureType
                    typedValue?: string | null
                    timestamp?: any | null
                    userId?: any | null
                  } | null> | null
                }
              | {
                  stringValues?: Array<string | null> | null
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                }
              | {
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                }
              | null
            > | null
          } | null> | null
        }
      | null
    > | null
  } | null
}

export type IGetUploadLogAggregationListQueryVariables = Types.Exact<{
  filter: Types.IUploadLogAggregationFilterInput
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>
  sort?: Types.InputMaybe<Types.ISortBy>
}>

export type IGetUploadLogAggregationListQuery = {
  uploadLogsAggregation?: {
    data: Array<{
      uploadLog: {
        fileType?: string | null
        fileCategory?: Types.FileCategory | null
        fileUrl?: string | null
        id?: any | null
        locationIds?: Array<any | null> | null
        locationName?: string | null
        projectId?: any | null
        projectName?: string | null
        sourceEntityCode?: string | null
        sourceEntityId?: any | null
        sourceEntityType?: Types.SourceEntityType | null
        sourceEntityTypeName?: string | null
        updatedAt?: any | null
        userCompanyId?: any | null
        userCompanyName?: string | null
        userId?: any | null
        userName?: string | null
        version?: number | null
        createdAt?: any | null
        workflowType?: any | null
        workflowCategory?: any | null
        isHidden?: boolean | null
        metadata?: Array<{
          key?: string | null
          value?: string | null
        } | null> | null
      }
      delivery?: {
        id?: any | null
        bookingId?: string | null
        note?: string | null
      } | null
      sitePermit?: {
        createdAt?: any | null
        createdBy: any
        endDate: any
        id?: any | null
        projectId: any
        startDate: any
        status: Types.SitePermitStatus
        threadId?: any | null
        title?: string | null
        typeId: any
        initialType?: string | null
        categoryId?: any | null
        linkedIn?: Array<any | null> | null
        linkedWorkflows?: Array<any | null> | null
        updatedAt?: any | null
        code?: string | null
        currentWorkflowStepId: any
        workflowStepLevel?: number | null
        isAutoActivationEnabled?: boolean | null
        recurringSettingsId?: any | null
        isDeleted?: boolean | null
        isAllDay?: boolean | null
        isLateRequest?: boolean | null
        specificInspectionOptions?: {
          deadlineTime?: any | null
          inspectionFrequency?: number | null
          inspectionFrequencyType?: Types.CalendricalType | null
          selectedDaysToRepeat?: Array<number | null> | null
        } | null
        stepSubmissions?: Array<{
          stepId: any
          userId: any
          submittedAt: any
          fields?: Array<
            | {
                fieldId: any
                type: Types.PermitFieldType
                instanceId: any
                parentInstanceId?: any | null
                parentValueIndex?: number | null
                attachmentValues?: Array<{
                  fileName: string
                  size: string
                  url: string
                } | null> | null
              }
            | {
                fieldId: any
                type: Types.PermitFieldType
                instanceId: any
                parentInstanceId?: any | null
                parentValueIndex?: number | null
                checklistValues?: Array<{
                  checklistItemId?: any | null
                  answer?: boolean | null
                } | null> | null
              }
            | {
                dateTimeValues?: Array<any | null> | null
                fieldId: any
                type: Types.PermitFieldType
                instanceId: any
                parentInstanceId?: any | null
                parentValueIndex?: number | null
              }
            | {
                fieldId: any
                type: Types.PermitFieldType
                instanceId: any
                parentInstanceId?: any | null
                parentValueIndex?: number | null
                locationValues?: Array<{
                  id: any
                  type?: Types.LocationType | null
                  levels?: Array<string | null> | null
                  preciseLocation?: {
                    bearing?: number | null
                    pitch?: number | null
                    latitude?: number | null
                    longitude?: number | null
                    zoom?: number | null
                    globeViewId?: any | null
                    imageUrl?: string | null
                    overviewImageUrl?: string | null
                  } | null
                } | null> | null
              }
            | {
                fieldId: any
                type: Types.PermitFieldType
                instanceId: any
                parentInstanceId?: any | null
                parentValueIndex?: number | null
                materialValues?: Array<{
                  materialId: any
                  procurementId?: string | null
                } | null> | null
              }
            | {
                fieldId: any
                type: Types.PermitFieldType
                instanceId: any
                parentInstanceId?: any | null
                parentValueIndex?: number | null
                materialResourceValues?: Array<{
                  locationId: any
                } | null> | null
              }
            | {
                fieldId: any
                type: Types.PermitFieldType
                instanceId: any
                parentInstanceId?: any | null
                parentValueIndex?: number | null
                measureValues?: Array<{
                  units?: string | null
                  value?: string | null
                } | null> | null
              }
            | {
                objectIdValues?: Array<any | null> | null
                fieldId: any
                type: Types.PermitFieldType
                instanceId: any
                parentInstanceId?: any | null
                parentValueIndex?: number | null
              }
            | {
                fieldId: any
                type: Types.PermitFieldType
                instanceId: any
                parentInstanceId?: any | null
                parentValueIndex?: number | null
                richTextValues?: Array<{
                  content?: string | null
                  attachments?: Array<{
                    fileName: string
                    size: string
                    url: string
                  } | null> | null
                } | null> | null
              }
            | {
                fieldId: any
                type: Types.PermitFieldType
                instanceId: any
                parentInstanceId?: any | null
                parentValueIndex?: number | null
                signatureValues?: Array<{
                  dataUrl?: string | null
                  fontFamily?: string | null
                  signatureType: Types.SignatureType
                  typedValue?: string | null
                  timestamp?: any | null
                  userId?: any | null
                } | null> | null
              }
            | {
                stringValues?: Array<string | null> | null
                fieldId: any
                type: Types.PermitFieldType
                instanceId: any
                parentInstanceId?: any | null
                parentValueIndex?: number | null
              }
            | {
                fieldId: any
                type: Types.PermitFieldType
                instanceId: any
                parentInstanceId?: any | null
                parentValueIndex?: number | null
                tableValues?: Array<{
                  cells?: Array<
                    | {
                        fieldId: any
                        type: Types.PermitFieldType
                        instanceId: any
                        parentInstanceId?: any | null
                        parentValueIndex?: number | null
                        attachmentValues?: Array<{
                          fileName: string
                          size: string
                          url: string
                        } | null> | null
                      }
                    | {
                        fieldId: any
                        type: Types.PermitFieldType
                        instanceId: any
                        parentInstanceId?: any | null
                        parentValueIndex?: number | null
                        checklistValues?: Array<{
                          checklistItemId?: any | null
                          answer?: boolean | null
                        } | null> | null
                      }
                    | {
                        dateTimeValues?: Array<any | null> | null
                        fieldId: any
                        type: Types.PermitFieldType
                        instanceId: any
                        parentInstanceId?: any | null
                        parentValueIndex?: number | null
                      }
                    | {
                        fieldId: any
                        type: Types.PermitFieldType
                        instanceId: any
                        parentInstanceId?: any | null
                        parentValueIndex?: number | null
                        locationValues?: Array<{
                          id: any
                          type?: Types.LocationType | null
                          levels?: Array<string | null> | null
                          preciseLocation?: {
                            bearing?: number | null
                            pitch?: number | null
                            latitude?: number | null
                            longitude?: number | null
                            zoom?: number | null
                            globeViewId?: any | null
                            imageUrl?: string | null
                            overviewImageUrl?: string | null
                          } | null
                        } | null> | null
                      }
                    | {
                        fieldId: any
                        type: Types.PermitFieldType
                        instanceId: any
                        parentInstanceId?: any | null
                        parentValueIndex?: number | null
                        materialValues?: Array<{
                          materialId: any
                          procurementId?: string | null
                        } | null> | null
                      }
                    | {
                        fieldId: any
                        type: Types.PermitFieldType
                        instanceId: any
                        parentInstanceId?: any | null
                        parentValueIndex?: number | null
                        materialResourceValues?: Array<{
                          locationId: any
                        } | null> | null
                      }
                    | {
                        fieldId: any
                        type: Types.PermitFieldType
                        instanceId: any
                        parentInstanceId?: any | null
                        parentValueIndex?: number | null
                        measureValues?: Array<{
                          units?: string | null
                          value?: string | null
                        } | null> | null
                      }
                    | {
                        objectIdValues?: Array<any | null> | null
                        fieldId: any
                        type: Types.PermitFieldType
                        instanceId: any
                        parentInstanceId?: any | null
                        parentValueIndex?: number | null
                      }
                    | {
                        fieldId: any
                        type: Types.PermitFieldType
                        instanceId: any
                        parentInstanceId?: any | null
                        parentValueIndex?: number | null
                        richTextValues?: Array<{
                          content?: string | null
                          attachments?: Array<{
                            fileName: string
                            size: string
                            url: string
                          } | null> | null
                        } | null> | null
                      }
                    | {
                        fieldId: any
                        type: Types.PermitFieldType
                        instanceId: any
                        parentInstanceId?: any | null
                        parentValueIndex?: number | null
                        signatureValues?: Array<{
                          dataUrl?: string | null
                          fontFamily?: string | null
                          signatureType: Types.SignatureType
                          typedValue?: string | null
                          timestamp?: any | null
                          userId?: any | null
                        } | null> | null
                      }
                    | {
                        stringValues?: Array<string | null> | null
                        fieldId: any
                        type: Types.PermitFieldType
                        instanceId: any
                        parentInstanceId?: any | null
                        parentValueIndex?: number | null
                      }
                    | {
                        fieldId: any
                        type: Types.PermitFieldType
                        instanceId: any
                        parentInstanceId?: any | null
                        parentValueIndex?: number | null
                      }
                    | null
                  > | null
                } | null> | null
              }
            | null
          > | null
        } | null> | null
        fields?: Array<
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              attachmentValues?: Array<{
                fileName: string
                size: string
                url: string
              } | null> | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              checklistValues?: Array<{
                checklistItemId?: any | null
                answer?: boolean | null
              } | null> | null
            }
          | {
              dateTimeValues?: Array<any | null> | null
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              locationValues?: Array<{
                id: any
                type?: Types.LocationType | null
                levels?: Array<string | null> | null
                preciseLocation?: {
                  bearing?: number | null
                  pitch?: number | null
                  latitude?: number | null
                  longitude?: number | null
                  zoom?: number | null
                  globeViewId?: any | null
                  imageUrl?: string | null
                  overviewImageUrl?: string | null
                } | null
              } | null> | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              materialValues?: Array<{
                materialId: any
                procurementId?: string | null
              } | null> | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              materialResourceValues?: Array<{ locationId: any } | null> | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              measureValues?: Array<{
                units?: string | null
                value?: string | null
              } | null> | null
            }
          | {
              objectIdValues?: Array<any | null> | null
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              richTextValues?: Array<{
                content?: string | null
                attachments?: Array<{
                  fileName: string
                  size: string
                  url: string
                } | null> | null
              } | null> | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              signatureValues?: Array<{
                dataUrl?: string | null
                fontFamily?: string | null
                signatureType: Types.SignatureType
                typedValue?: string | null
                timestamp?: any | null
                userId?: any | null
              } | null> | null
            }
          | {
              stringValues?: Array<string | null> | null
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              tableValues?: Array<{
                cells?: Array<
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      attachmentValues?: Array<{
                        fileName: string
                        size: string
                        url: string
                      } | null> | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      checklistValues?: Array<{
                        checklistItemId?: any | null
                        answer?: boolean | null
                      } | null> | null
                    }
                  | {
                      dateTimeValues?: Array<any | null> | null
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      locationValues?: Array<{
                        id: any
                        type?: Types.LocationType | null
                        levels?: Array<string | null> | null
                        preciseLocation?: {
                          bearing?: number | null
                          pitch?: number | null
                          latitude?: number | null
                          longitude?: number | null
                          zoom?: number | null
                          globeViewId?: any | null
                          imageUrl?: string | null
                          overviewImageUrl?: string | null
                        } | null
                      } | null> | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      materialValues?: Array<{
                        materialId: any
                        procurementId?: string | null
                      } | null> | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      materialResourceValues?: Array<{
                        locationId: any
                      } | null> | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      measureValues?: Array<{
                        units?: string | null
                        value?: string | null
                      } | null> | null
                    }
                  | {
                      objectIdValues?: Array<any | null> | null
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      richTextValues?: Array<{
                        content?: string | null
                        attachments?: Array<{
                          fileName: string
                          size: string
                          url: string
                        } | null> | null
                      } | null> | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      signatureValues?: Array<{
                        dataUrl?: string | null
                        fontFamily?: string | null
                        signatureType: Types.SignatureType
                        typedValue?: string | null
                        timestamp?: any | null
                        userId?: any | null
                      } | null> | null
                    }
                  | {
                      stringValues?: Array<string | null> | null
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                    }
                  | null
                > | null
              } | null> | null
            }
          | null
        > | null
      } | null
    }>
  } | null
}

export type IGetUploadLogFacetsQueryVariables = Types.Exact<{
  filter: Types.IUploadLogAggregationFilterInput
}>

export type IGetUploadLogFacetsQuery = {
  uploadLogsFacets?: {
    companyFilters?: Array<{
      key?: string | null
      count?: number | null
    } | null> | null
    locationFilters?: Array<{
      key?: string | null
      count?: number | null
    } | null> | null
    fileCategoryFilters?: Array<{
      key?: string | null
      count?: number | null
    } | null> | null
    fileTypeFilters?: Array<{
      key?: string | null
      count?: number | null
    } | null> | null
    userFilters?: Array<{
      key?: string | null
      count?: number | null
    } | null> | null
    workflowCategoryFilters?: Array<{
      key?: string | null
      count?: number | null
    } | null> | null
    workflowTypeFilters?: Array<{
      key?: string | null
      count?: number | null
    } | null> | null
  } | null
}

export const UploadLogFieldsFragmentDoc = gql`
  fragment UploadLogFields on UploadLog {
    fileType
    fileCategory
    fileUrl
    id
    locationIds
    locationName
    metadata {
      key
      value
    }
    projectId
    projectName
    sourceEntityCode
    sourceEntityId
    sourceEntityType
    sourceEntityTypeName
    updatedAt
    userCompanyId
    userCompanyName
    userId
    userName
    version
    createdAt
    updatedAt
    workflowType
    workflowCategory
    isHidden
  }
`
export const UploadLogAggregatedFieldsFragmentDoc = gql`
  fragment UploadLogAggregatedFields on UploadLogAggregated {
    uploadLog {
      ...UploadLogFields
    }
    delivery {
      id
      bookingId
      note
    }
    sitePermit {
      ...PermitModelFields
    }
  }
  ${UploadLogFieldsFragmentDoc}
  ${PermitModelFieldsFragmentDoc}
`
export const GetSignedUnverifiedUploadUrlDocument = gql`
  query GetSignedUnverifiedUploadUrl(
    $fileName: String!
    $uploadingType: String!
  ) {
    getSignedUnverifiedUploadUrl(
      fileName: $fileName
      uploadingType: $uploadingType
    ) {
      filePath
      signedUrl
      contentType
    }
  }
`

/**
 * __useGetSignedUnverifiedUploadUrlQuery__
 *
 * To run a query within a React component, call `useGetSignedUnverifiedUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignedUnverifiedUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignedUnverifiedUploadUrlQuery({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      uploadingType: // value for 'uploadingType'
 *   },
 * });
 */
export function useGetSignedUnverifiedUploadUrlQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetSignedUnverifiedUploadUrlQuery,
    IGetSignedUnverifiedUploadUrlQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IGetSignedUnverifiedUploadUrlQuery,
    IGetSignedUnverifiedUploadUrlQueryVariables
  >(GetSignedUnverifiedUploadUrlDocument, options)
}
export function useGetSignedUnverifiedUploadUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetSignedUnverifiedUploadUrlQuery,
    IGetSignedUnverifiedUploadUrlQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IGetSignedUnverifiedUploadUrlQuery,
    IGetSignedUnverifiedUploadUrlQueryVariables
  >(GetSignedUnverifiedUploadUrlDocument, options)
}
export type GetSignedUnverifiedUploadUrlQueryHookResult = ReturnType<
  typeof useGetSignedUnverifiedUploadUrlQuery
>
export type GetSignedUnverifiedUploadUrlLazyQueryHookResult = ReturnType<
  typeof useGetSignedUnverifiedUploadUrlLazyQuery
>
export type GetSignedUnverifiedUploadUrlQueryResult = Apollo.QueryResult<
  IGetSignedUnverifiedUploadUrlQuery,
  IGetSignedUnverifiedUploadUrlQueryVariables
>
export const VerifyUploadedFileDocument = gql`
  query VerifyUploadedFile($input: GenerateSignedUploadUrlInput!) {
    verifyUploadedFile(input: $input) {
      filePath
      signedUrl
      fileURL
      contentType
      uploadLog {
        ...UploadLogFields
      }
    }
  }
  ${UploadLogFieldsFragmentDoc}
`

/**
 * __useVerifyUploadedFileQuery__
 *
 * To run a query within a React component, call `useVerifyUploadedFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyUploadedFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyUploadedFileQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyUploadedFileQuery(
  baseOptions: Apollo.QueryHookOptions<
    IVerifyUploadedFileQuery,
    IVerifyUploadedFileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IVerifyUploadedFileQuery,
    IVerifyUploadedFileQueryVariables
  >(VerifyUploadedFileDocument, options)
}
export function useVerifyUploadedFileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IVerifyUploadedFileQuery,
    IVerifyUploadedFileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IVerifyUploadedFileQuery,
    IVerifyUploadedFileQueryVariables
  >(VerifyUploadedFileDocument, options)
}
export type VerifyUploadedFileQueryHookResult = ReturnType<
  typeof useVerifyUploadedFileQuery
>
export type VerifyUploadedFileLazyQueryHookResult = ReturnType<
  typeof useVerifyUploadedFileLazyQuery
>
export type VerifyUploadedFileQueryResult = Apollo.QueryResult<
  IVerifyUploadedFileQuery,
  IVerifyUploadedFileQueryVariables
>
export const GetUploadLogsDocument = gql`
  query GetUploadLogs($projectId: ObjectId!) {
    getUploadLogs(projectId: $projectId) {
      ...UploadLogFields
    }
  }
  ${UploadLogFieldsFragmentDoc}
`

/**
 * __useGetUploadLogsQuery__
 *
 * To run a query within a React component, call `useGetUploadLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadLogsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetUploadLogsQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetUploadLogsQuery,
    IGetUploadLogsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetUploadLogsQuery, IGetUploadLogsQueryVariables>(
    GetUploadLogsDocument,
    options,
  )
}
export function useGetUploadLogsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetUploadLogsQuery,
    IGetUploadLogsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetUploadLogsQuery, IGetUploadLogsQueryVariables>(
    GetUploadLogsDocument,
    options,
  )
}
export type GetUploadLogsQueryHookResult = ReturnType<
  typeof useGetUploadLogsQuery
>
export type GetUploadLogsLazyQueryHookResult = ReturnType<
  typeof useGetUploadLogsLazyQuery
>
export type GetUploadLogsQueryResult = Apollo.QueryResult<
  IGetUploadLogsQuery,
  IGetUploadLogsQueryVariables
>
export const DeleteUploadLogDocument = gql`
  mutation DeleteUploadLog($uploadLogId: ObjectId!) {
    deleteUploadLog(id: $uploadLogId)
  }
`
export type IDeleteUploadLogMutationFn = Apollo.MutationFunction<
  IDeleteUploadLogMutation,
  IDeleteUploadLogMutationVariables
>

/**
 * __useDeleteUploadLogMutation__
 *
 * To run a mutation, you first call `useDeleteUploadLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUploadLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUploadLogMutation, { data, loading, error }] = useDeleteUploadLogMutation({
 *   variables: {
 *      uploadLogId: // value for 'uploadLogId'
 *   },
 * });
 */
export function useDeleteUploadLogMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteUploadLogMutation,
    IDeleteUploadLogMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IDeleteUploadLogMutation,
    IDeleteUploadLogMutationVariables
  >(DeleteUploadLogDocument, options)
}
export type DeleteUploadLogMutationHookResult = ReturnType<
  typeof useDeleteUploadLogMutation
>
export type DeleteUploadLogMutationResult =
  Apollo.MutationResult<IDeleteUploadLogMutation>
export type DeleteUploadLogMutationOptions = Apollo.BaseMutationOptions<
  IDeleteUploadLogMutation,
  IDeleteUploadLogMutationVariables
>
export const SaveUploadLogDocument = gql`
  mutation SaveUploadLog($uploadLog: UploadLogInput!) {
    saveUploadLog(uploadLog: $uploadLog) {
      ...UploadLogFields
    }
  }
  ${UploadLogFieldsFragmentDoc}
`
export type ISaveUploadLogMutationFn = Apollo.MutationFunction<
  ISaveUploadLogMutation,
  ISaveUploadLogMutationVariables
>

/**
 * __useSaveUploadLogMutation__
 *
 * To run a mutation, you first call `useSaveUploadLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUploadLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUploadLogMutation, { data, loading, error }] = useSaveUploadLogMutation({
 *   variables: {
 *      uploadLog: // value for 'uploadLog'
 *   },
 * });
 */
export function useSaveUploadLogMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISaveUploadLogMutation,
    ISaveUploadLogMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ISaveUploadLogMutation,
    ISaveUploadLogMutationVariables
  >(SaveUploadLogDocument, options)
}
export type SaveUploadLogMutationHookResult = ReturnType<
  typeof useSaveUploadLogMutation
>
export type SaveUploadLogMutationResult =
  Apollo.MutationResult<ISaveUploadLogMutation>
export type SaveUploadLogMutationOptions = Apollo.BaseMutationOptions<
  ISaveUploadLogMutation,
  ISaveUploadLogMutationVariables
>
export const GetUploadLogAggregationListDocument = gql`
  query GetUploadLogAggregationList(
    $filter: UploadLogAggregationFilterInput!
    $offset: Int
    $limit: Int
    $sort: SortBy
  ) {
    uploadLogsAggregation(
      filter: $filter
      offset: $offset
      limit: $limit
      sort: $sort
    ) {
      data {
        ...UploadLogAggregatedFields
      }
    }
  }
  ${UploadLogAggregatedFieldsFragmentDoc}
`

/**
 * __useGetUploadLogAggregationListQuery__
 *
 * To run a query within a React component, call `useGetUploadLogAggregationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadLogAggregationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadLogAggregationListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetUploadLogAggregationListQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetUploadLogAggregationListQuery,
    IGetUploadLogAggregationListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IGetUploadLogAggregationListQuery,
    IGetUploadLogAggregationListQueryVariables
  >(GetUploadLogAggregationListDocument, options)
}
export function useGetUploadLogAggregationListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetUploadLogAggregationListQuery,
    IGetUploadLogAggregationListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IGetUploadLogAggregationListQuery,
    IGetUploadLogAggregationListQueryVariables
  >(GetUploadLogAggregationListDocument, options)
}
export type GetUploadLogAggregationListQueryHookResult = ReturnType<
  typeof useGetUploadLogAggregationListQuery
>
export type GetUploadLogAggregationListLazyQueryHookResult = ReturnType<
  typeof useGetUploadLogAggregationListLazyQuery
>
export type GetUploadLogAggregationListQueryResult = Apollo.QueryResult<
  IGetUploadLogAggregationListQuery,
  IGetUploadLogAggregationListQueryVariables
>
export const GetUploadLogFacetsDocument = gql`
  query GetUploadLogFacets($filter: UploadLogAggregationFilterInput!) {
    uploadLogsFacets(filter: $filter) {
      companyFilters {
        key
        count
      }
      locationFilters {
        key
        count
      }
      fileCategoryFilters {
        key
        count
      }
      fileTypeFilters {
        key
        count
      }
      userFilters {
        key
        count
      }
      workflowCategoryFilters {
        key
        count
      }
      workflowTypeFilters {
        key
        count
      }
    }
  }
`

/**
 * __useGetUploadLogFacetsQuery__
 *
 * To run a query within a React component, call `useGetUploadLogFacetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadLogFacetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadLogFacetsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetUploadLogFacetsQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetUploadLogFacetsQuery,
    IGetUploadLogFacetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IGetUploadLogFacetsQuery,
    IGetUploadLogFacetsQueryVariables
  >(GetUploadLogFacetsDocument, options)
}
export function useGetUploadLogFacetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetUploadLogFacetsQuery,
    IGetUploadLogFacetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IGetUploadLogFacetsQuery,
    IGetUploadLogFacetsQueryVariables
  >(GetUploadLogFacetsDocument, options)
}
export type GetUploadLogFacetsQueryHookResult = ReturnType<
  typeof useGetUploadLogFacetsQuery
>
export type GetUploadLogFacetsLazyQueryHookResult = ReturnType<
  typeof useGetUploadLogFacetsLazyQuery
>
export type GetUploadLogFacetsQueryResult = Apollo.QueryResult<
  IGetUploadLogFacetsQuery,
  IGetUploadLogFacetsQueryVariables
>
